import { render, staticRenderFns } from "./Top4Member.vue?vue&type=template&id=6f8e061a&scoped=true"
import script from "./Top4Member.vue?vue&type=script&lang=js"
export * from "./Top4Member.vue?vue&type=script&lang=js"
import style0 from "./Top4Member.vue?vue&type=style&index=0&id=6f8e061a&prod&lang=scss&scoped=true"
import style1 from "./Top4Member.vue?vue&type=style&index=1&id=6f8e061a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8e061a",
  null
  
)

export default component.exports